import React, { FC } from 'react';

import RewardRedemptionIncrementor from 'pages/loyalty/loyalty-in-restaurant-redemption/reward-redemption-list/badge-and-incrementor/reward-redemption-incrementor';
import {
  ICartEntryReward,
  ICartEntryType,
  useInRestaurantRedemptionContext,
} from 'state/loyalty/in-restaurant-redemption';

interface IIncentiveCardInRestaurantIncrementorProps {
  rewardId: string;
}

export const IncentiveCardInRestaurantIncrementor: FC<IIncentiveCardInRestaurantIncrementorProps> = ({
  rewardId,
}) => {
  const { inRestaurantRedemptionCart } = useInRestaurantRedemptionContext();

  const cartEntry = inRestaurantRedemptionCart?.find(
    (entry): entry is ICartEntryReward =>
      entry.type === ICartEntryType.REWARD && entry.details.reward._id === rewardId
  );

  if (!cartEntry) {
    return null;
  }

  return <RewardRedemptionIncrementor cartEntry={cartEntry} />;
};
